import React from "react";
import { Text, View, StyleSheet } from "react-native";

import Config from "../config/Config";

const config = new Config();

const OrderElement = ({ item }) => {
    const {id, number, origin, firstName, lastName, dateCreated, total, status} = item;

    const getStatusBackground = (status, isOrderId) => {
        switch(status) {
            case 'pending':
            case 'on-hold':
                return origin === 'ifood' && isOrderId ? 
                    {backgroundColor: config.IFOOD_COLOR} :
                    {backgroundColor: config.ON_HOLD_COLOR};
            case 'processing':
                return {backgroundColor: config.PROCESSING_COLOR};
            case 'completed':
                return {backgroundColor: config.COMPLETED_COLOR};
            case 'cancelled':
                return {backgroundColor: config.CANCELLED_COLOR};
            default:
                return {backgroundColor: config.ON_HOLD_COLOR};
        }
    }

    const getStatusBorder = (status) => {
        switch(status) {
            case 'pending':
            case 'on-hold':
              return {borderColor: config.ON_HOLD_COLOR, borderWidth: 3};
            case 'processing':
                return {borderColor: config.PROCESSING_COLOR, borderWidth: 3};
            case 'completed':
                return {borderColor: config.COMPLETED_COLOR, borderWidth: 3};
            case 'cancelled':
                return {borderColor: config.CANCELLED_COLOR, borderWidth: 3};
            default:
                return {borderColor: config.ON_HOLD_COLOR, borderWidth: 3};
        }
    }
    const localeDate = new Date(dateCreated);

    return (
        <View style={styles.orderStyle}>
            <View style={[styles.orderNumber, styles.startEndFields, getStatusBackground(status, true)]}>
                <Text>{number}</Text>
            </View>
            <View style={styles.orderInfo}>
                <View style={[getStatusBorder(status), styles.orderFields]}>
                    <Text style={styles.date}>{ localeDate.toLocaleDateString({minimumSignificantDigits: 2}).substring(0,5) }</Text>
                    <Text style={styles.date}>{ localeDate.toLocaleTimeString({minimumSignificantDigits: 2}).substring(0,5) }</Text>
                    <Text style={styles.name}>{firstName} {lastName}</Text>
                </View>
            </View>
            <View style={[styles.total, styles.startEndFields, getStatusBackground(status, false)]}>
                <Text>R$ {parseFloat(total).toFixed(2)}</Text>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    orderStyle: {
        flexDirection: 'row',
        flex: 1
    },
    orderInfo: {
        justifyContent: 'flex-start',
        flex: 5
    },
    date: {
        alignSelf: 'center',
        fontSize: 15,
        paddingLeft: 5,
        maxWidth: 65
    },
    name: {
        alignSelf: 'center',
        fontSize: 16,
        padding: 5,
        flexGrow: 1,
    },
    startEndFields: {
        fontSize: 16,
        justifyContent: 'center', 
        alignItems: 'center',
        padding: 2
    },
    orderNumber: {
        fontSize: 15,
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
        width: 65
    },
    orderFields: {
        flexDirection: 'row'
    },
    icons: {
        textAlignVertical: 'center',
        padding: 10
    },
    total: {
        fontSize: 15,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        width: 85
    }
});

export default OrderElement;